import { render } from "./EditDepotSingleProduct.vue?vue&type=template&id=d286784e"
import script from "./EditDepotSingleProduct.vue?vue&type=script&lang=js"
export * from "./EditDepotSingleProduct.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__